<template>
    <div class="">
        <drawer 
            :title="addEditTitle" 
            :dialogShow="addEditShow" 
            @handleChange="handleChangeDrawer"
        >
            <div slot="body">
                <div class="pay-mains">
                    <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
                        <el-form-item label="客户姓名：">
                            {{ form.customerName }}
                        </el-form-item>
                        <el-form-item label="电话号码：">
                            {{ form.mobile }}
                        </el-form-item>
                        <el-form-item label="客户编号：">
                            {{ form.customerNo }}
                        </el-form-item>
                        <el-form-item label="套餐类型：">
                            {{ form.cardOldIdCn }}
                        </el-form-item>
                        <el-form-item label="套餐次数：">
                            {{ form.originNum }}
                        </el-form-item>
                    </el-form>
                    <el-table :data="list" border class="mt10">
                        <el-table-column prop="" label="签名">
                            <template slot-scope="scope">
                                <el-image :src="scope.row.imgUrl?scope.row.imgUrl:imgs" :preview-src-list="imgs"></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="tradeNum" label="使用次数"></el-table-column>
                        <el-table-column prop="cardName" label="套餐类型"></el-table-column>
                        <el-table-column prop="oxCtime" label="消费时间">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.oxCtime) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </div>
                <div class="drawer-footer">
                    <div class="btns">
                        <el-button type="danger" class="large-btn" @click="onSubmit">返回</el-button>
                    </div>
                </div>
            </div>
        </drawer>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
export default {
    mixins: [minxin],
    components:{drawer},
    data () {
        return {
            addEditTitle: '消费详情',
            addEditShow: false,
            form: {
                mobile: ''
            },
            columns: [],
            list: [],
            query: {
                cardOldBookId: '',
            },
            url: this.$url.cardOld.pageConsume,
            cardOldName: '',
            showPicker: false,
            imgs: require('../../../assets/images/notImg.png'),
        }
    },
    created(){
        this.editInit();
    },
    methods: {
        editInit(){
            this.$on('set',function(org){
                // Object.assign(this.$data,this.$options.data());
                this.list = [];
                this.query.cardOldBookId = org.id;
                this.getList();
                this.$api.get(this.$url.cardOld.get,{
                    id: org.id
                }).then( res => {
                    if(res){
                        this.form = res;
                        this.form.text = this.form.cardOldIdCn;
                        this.cardOldName = this.form.cardOldIdCn;
                    }
                }).catch(error => {
    
                })
                this.addEditShow = true;
            })    
        },
        handleChangeDrawer(){
            this.addEditShow = false;
            this.$emit('change',false);
        },
        onSubmit(values){
            this.addEditShow = false;
        },
    }
}
</script>
<style scoped lang="less">

/deep/ .el-input--small .el-input__inner{
    width: 200px;
    height: 40px;
    line-height: 40px;
}
/deep/ .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label{
    line-height: 40px;
}
.pay-mains{
    padding: 30px;
}
</style>